// vim: set ts=2 sts=2 sw=2 et:

// Replica lo que hace hoy el ProfileEditor de la web con la foto del atleta (apps/nextjs/.../image-upload.tsx):
// recorte cuadrado a 250×250, JPEG 0,9 y después WebP 0,8. Sirve para ver en el lab cómo se ven las fotos
// guardadas y compararlas con la original.

export const STORED_PHOTO_SIZE = 250;

const loadImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("No se pudo cargar la foto"));
    image.src = url;
  });

const encode = (canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error(`No se pudo codificar ${type}`))), type, quality);
  });

const drawSquare = (image: HTMLImageElement, size: number): HTMLCanvasElement => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext("2d");
  if (context === null) throw new Error("No hay contexto 2D");
  const side = Math.min(image.naturalWidth, image.naturalHeight);
  const x = (image.naturalWidth - side) / 2;
  const y = (image.naturalHeight - side) / 2;
  context.drawImage(image, x, y, side, side, 0, 0, size, size);
  return canvas;
};

export const simulateStoredPhoto = async (url: string): Promise<string> => {
  const jpeg = await encode(drawSquare(await loadImage(url), STORED_PHOTO_SIZE), "image/jpeg", 0.9);
  const jpegUrl = URL.createObjectURL(jpeg);
  try {
    const webp = await encode(drawSquare(await loadImage(jpegUrl), STORED_PHOTO_SIZE), "image/webp", 0.8);
    return URL.createObjectURL(webp);
  } finally {
    URL.revokeObjectURL(jpegUrl);
  }
};

// Silueta de prueba para ver el marco sin subir una foto real.
export const SAMPLE_PHOTO_URL = `data:image/svg+xml;utf8,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' width='800' height='800' viewBox='0 0 800 800'>" +
    "<defs><linearGradient id='f' x1='0' y1='0' x2='0' y2='1'><stop offset='0' stop-color='#7d8c99'/>" +
    "<stop offset='1' stop-color='#303a44'/></linearGradient><linearGradient id='r' x1='0' y1='0' x2='0' y2='1'>" +
    "<stop offset='0' stop-color='#26221f'/><stop offset='1' stop-color='#0f0d0c'/></linearGradient></defs>" +
    "<rect width='800' height='800' fill='url(#f)'/><rect x='340' y='360' width='120' height='150' fill='#c49a80'/>" +
    "<ellipse cx='400' cy='285' rx='118' ry='140' fill='#cfa68b'/>" +
    "<path d='M120 800 C130 560 250 470 400 460 C550 470 670 560 680 800 Z' fill='url(#r)'/></svg>",
)}`;
